(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["padel-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-padel-collection-link]').forEach(link => {
  const collection = document.querySelector('[id$="__featured_collection"]');
  if (collection) link.setAttribute('href', '#' + collection.id);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pls-tees-header"]) return;
  try {
    
if (!customElements.get('pl-menu-drawer')) {
  customElements.define('pl-menu-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.plReady) return;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-pl-open]');
      const close = this.querySelector('[data-pl-close]');
      if (!dialog || !trigger || typeof dialog.showModal !== 'function') return;
      this.plReady = true;
      trigger.hidden = false;
      const languageForm = this.querySelector('form.pls-tees-language-form');
      const languageInput = languageForm && languageForm.querySelector('[name="language_code"]');
      const switchLanguage = (locale, manual) => {
        if (!languageForm || !languageInput || !['de', 'en'].includes(locale)) return;
        if (manual) sessionStorage.setItem('plsTeesLanguageChoice', locale);
        if (this.dataset.locale !== locale) {
          languageInput.value = locale;
          languageForm.requestSubmit();
        }
      };
      this.querySelectorAll('[data-pl-language]').forEach(button => {
        button.addEventListener('click', () => switchLanguage(button.dataset.plLanguage, true));
      });
      try {
        const manual = sessionStorage.getItem('plsTeesLanguageChoice');
        const country = this.dataset.country;
        const desired = manual || (country ? (country === 'DE' ? 'de' : 'en') : null);
        if (desired && desired !== this.dataset.locale && !sessionStorage.getItem('plsTeesLanguagePending')) {
          sessionStorage.setItem('plsTeesLanguagePending', desired);
          switchLanguage(desired, false);
        } else if (desired === this.dataset.locale) {
          sessionStorage.removeItem('plsTeesLanguagePending');
        }
      } catch (error) {
        /* Session storage can be disabled by the visitor. */
      }
      const languagePicker = this.querySelector('.pls-tees-header__language-picker');
      if (languagePicker) {
        document.addEventListener('pointerdown', (event) => {
          if (!languagePicker.contains(event.target)) languagePicker.open = false;
        });
      }
      trigger.addEventListener('click', () => {
        if (languagePicker) languagePicker.open = false;
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('pls-tees-menu-open');
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('pls-tees-menu-open');
        trigger.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      document.documentElement.classList.remove('pls-tees-menu-open');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
